import {svgIconWrapper} from '../svg-icon-wrapper';

import ProductReport from './product-report-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ProductReport {...validProps} />;
}

SvgComponent.iconName = 'product-report';

export const ProductReportIcon = svgIconWrapper(SvgComponent);
